import { LegalFooter } from "../../components";
import { t } from "../../i18n/t";

/* The labels/tags are translated strings, not keys: `tests/i18n.test.ts` finds a reference by matching a
 * quoted literal in the translate call, so a key held in a data table reads as unreferenced. Module-scope
 * calls are safe: `en.ts` is a plain frozen object and there is no locale switch. */
const STEPS = [
  { label: t("auth.brand_step_1"), tag: t("auth.brand_tag_1") },
  { label: t("auth.brand_step_2"), tag: t("auth.brand_tag_2") },
  { label: t("auth.brand_step_3"), tag: t("auth.brand_tag_3") },
  { label: t("auth.brand_step_4"), tag: t("auth.brand_tag_4") },
  { label: t("auth.brand_step_5"), tag: t("auth.brand_tag_5") },
] as const;

/**
 * The SignIn split layout (guide §5 step 7): the blue brand panel on the left — logo, headline, the five
 * numbered steps with their tags, the vendor line — hidden below 720 px, and the page's card centred in the
 * right column, 380 px wide. Every anonymous screen (`/auth/*`, `/login`, `/auth/accept-invite`) sits in it.
 * The content is a normal `<main>` (the screens' `Page`), so the h1/landmark conventions are untouched.
 */
export function AuthLayout({ children }: { children: React.ReactNode }): JSX.Element {
  return (
    <div className="authlayout">
      <aside className="authbrand">
        <div className="authbrand__logo">
          {/* Theme-invariant by design: the white square and blue L, exactly like the top bar's logo. */}
          <span className="authbrand__mark" aria-hidden="true">
            L
          </span>
          {t("common.app_name")}
        </div>
        <div className="authbrand__body">
          <p className="authbrand__headline">
            {t("auth.brand_headline_1")}
            <br />
            {t("auth.brand_headline_2")}
          </p>
          <div aria-label={t("auth.brand_steps_label")}>
            {STEPS.map((step, index) => (
              <div className="authstep" key={step.label}>
                <span className="authbrand__mono">{String(index + 1).padStart(2, "0")}</span>
                <span>{step.label}</span>
                <span className="authbrand__mono authstep__tag">{step.tag}</span>
              </div>
            ))}
          </div>
        </div>
        <span className="authbrand__mono authbrand__vendors">{t("auth.brand_vendors")}</span>
      </aside>
      <div className="authmain">
        {children}
        <LegalFooter />
      </div>
    </div>
  );
}
